import withConfigTransport from '../../../services/config-transport/withConfigTransport'
import VaFileUploadSingleItem from './VaFileUploadSingleItem.vue'

export default withConfigTransport(VaFileUploadSingleItem)
